import React from 'react';
import { Col, Fill, Row } from '../../components/RowCol';
import logo from '../../images/jeopardy.png';
import Button from '../../components/Button';
import Spacer from '../../components/Spacer';

type Props = {};
type State = {};

class Home extends React.Component<Props, State> {
	render() {
		return (
			<Fill style={{
				padding: '50px',
				color: 'white',
			}}>
				<Col fill center>
					<img
						alt="Jeopardy!"
						src={logo}
						style={{
							height: '150px',
						}}
					/>

					<Spacer vertical={40} />

					<Row>
						<Button
							label="Question Editor"
							onClick={() => {
								window.open('questions', '_blank')
							}}
						/>

						<Spacer horizontal={50} />

						<Button
							label="Game Board"
							onClick={() => {
								window.open('game', '_blank')
							}}
						/>

						<Spacer horizontal={50} />

						<Button
							label="Control Panel"
							onClick={() => {
								window.open('control-panel', '_blank')
							}}
						/>
					</Row>

				</Col>
			</Fill>
		);
	}
}

export default Home;
